import React from 'react';

export const ProductPricing: React.FC = () => (
  <section className="fpv-pilot-pricing-section">
    <div className="fpv-pilot-pricing-content">
      <h2 className="fpv-pilot-pricing-title">Ready for the next stage?</h2>
      <p className="fpv-pilot-pricing-description">
        Grab your FPV.One Pilots and elevate your flying experience to a whole
        new level.
      </p>
      <div className="dreamX__discover--button">
        <a
          href="https://shop.orqafpv.com/products/orqa-orqa-fpv-one-pilot"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--primary btn--med"
          onMouseDown={event => event.preventDefault()}
        >
          buy now
        </a>
      </div>
    </div>
  </section>
);
